import { TuiComparator } from '@taiga-ui/addon-table';
import { VerticalType } from 'src/app/enum/vertical-type/verticalType.enum';

export interface ProductData {
  freelancePoolConfigurationGuid: string;
  poolPrice: number;
  poolProfitMargin: number;
  productDescription: string;
  productKey: string;
}

export const poolPriceComparator: TuiComparator<ProductData> = (a, b) =>
  a.poolPrice - b.poolPrice;

export const poolProfitMarginComparator: TuiComparator<ProductData> = (a, b) =>
  a.poolProfitMargin - b.poolProfitMargin;

export const productDescriptionComparator: TuiComparator<ProductData> = (
  a,
  b
) => a.productDescription.localeCompare(b.productDescription);

export interface ProductInformationItem {
  productData: ProductData[];
  IsAvailableForFreelancePool: boolean;
  verticalType: VerticalType;
  tableOpen?: boolean;
}

export interface ProductInformation {
  productInformationData: ProductInformationItem[];
  currencySymbol: string;
}

export interface OperativeZoneConfiguration {
  operativeZoneConfigurationGuid: string;
  description: string;
  timeLimit: number;
}

export const descriptionComparator: TuiComparator<
  OperativeZoneConfiguration
> = (a, b) => a.description.localeCompare(b.description);

export const timeLimitComparator: TuiComparator<OperativeZoneConfiguration> = (
  a,
  b
) => a.timeLimit - b.timeLimit;

export interface FreelancePoolConfiguration {
  freelancePoolConfiguration: OperativeZoneConfiguration[];
}

export interface HeaderTableInfo {
  Title?: string;
  Sticky?: boolean;
  Key?: string | any;
  Class?: string;
  Size?: string;
  TooltipKey?: string;
  Sortable?: TuiComparator<any> | null;
}
